import React from 'react';
import '../App.css';
import { Usuario } from '../system/Usuario/Usuario';
import SystemClient from '../system/SystemClient';
import { Icon, Text, useTheme } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../common/routes';

interface IHome {
  user?: Usuario;
  system: SystemClient;
}

export const Home = (props: IHome) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <div>
      <header className="App-header" style={{ backgroundColor: theme.palette.white }}>
        <Text variant="xLarge">Bienvenido a LarrySport</Text>

        {props.user ? (
          <>
            {props.user.getFederacion() && props.user.getFederacion()?.getLogo() ? (
              <img
                src={props.system
                  .getFederacionSystem()
                  .getUrlForImage(String(props.user.getFederacion()?.getLogo()))}
                className="App-logo"
                alt="logo"
              />
            ) : (
              <img src={'/img/logo_cah.jpg'} className="App-logo" alt="logo" />
            )}
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            {/* <div style={{color: 'black'}}><Text variant="xLarge"><Icon iconName="WifiWarning4" style={{marginRight: 10}}></Icon>Sin conexión</Text></div> */}
            <div
              onClick={() => {
                navigate(routes.planilla_partido_programado.route);
              }}
            >
              <Text variant="xLarge" className="link-styles">
                <Icon iconName="AccountActivity" style={{ marginRight: 10 }}></Icon>Ir a planilla online
              </Text>
            </div>

            {/* <div
              onClick={() => {
                navigate(routes.planilla_partido_offline.route);
              }}
            >
              <Text variant="xLarge" className="link-styles">
                <Icon iconName="WifiWarning4" style={{ marginRight: 10 }}></Icon>Estas sin conexion - Ir a
                planilla offline
              </Text>
            </div> */}
          </div>
        )}
      </header>
    </div>
  );
};
